import List from 'src/storage/list';

class AllPatientsModel extends List {
  id = 'all_patients';
  defaultState = () => ({
    current: 'recent',
    pageIndex: 0,
    status: 'all',
    sortBy: {
      key: 'created',
      desc: true
    }
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  sortBy = null;
  apiConfig = {
    refresh: {
      url: 'admin/patient/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'admin/patient/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'admin/patient/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    remove: {
      url: 'admin/patient/remove',
      validation: {
        id: 'userId'
      },
      cancellable: false
    }
  };

  _events = {
    adminUpdatePatient: 'adminUpdatePatient'
  };

  adminUpdatePatient = (data) => {
    this._mergeItems([data]);
  };

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      sortBy: this.state.sortBy,
      status: this.state.status === 'all' ? null : this.state.status
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }

  remove = (id, cb) => {
    this.api('remove', { id }, (err, res, success) => {
      if (success) {
        this.removeItem(id);
      }
      cb && cb(err, res, success);
    });
  };
}

const model = new AllPatientsModel();
export default model;
